// Local SEO content variations to avoid duplicate content

export const localContentVariations = {
  intro: [
    "oferece serviços completos de {service} com galpão coberto, produtos profissionais e equipe especializada",
    "é referência em {service} na região, com estrutura moderna e profissionais qualificados",
    "conta com os melhores profissionais em {service}, utilizando produtos premium e técnicas avançadas",
    "se destaca pela qualidade em {service}, oferecendo atendimento personalizado e resultados excepcionais"
  ],
  
  differential: [
    "Nosso diferencial está no cuidado com cada detalhe do seu veículo",
    "Trabalhamos com equipamentos de última geração e produtos de alta performance",
    "Nossa equipe é treinada regularmente nas melhores técnicas do mercado",
    "Garantimos satisfação total com acabamento profissional e duradouro"
  ],
  
  coverage: [
    "Atendemos moradores de {neighborhood} e região com excelência",
    "Localização estratégica facilita o acesso de quem mora em {neighborhood}",
    "Clientes de {neighborhood} contam com serviço rápido e de qualidade",
    "Estamos próximos de {neighborhood} para melhor atendê-lo"
  ],
  
  cta: [
    "Agende agora seu serviço em {neighborhood}",
    "Solicite um orçamento sem compromisso para {neighborhood}",
    "Entre em contato e conheça nossos serviços em {neighborhood}",
    "Fale conosco e garanta qualidade premium em {neighborhood}"
  ]
};

export const getLocalizedContent = (neighborhood, city, serviceType, index = 0) => {
  const idx = index % localContentVariations.intro.length;
  
  return {
    intro: localContentVariations.intro[idx]
      .replace('{service}', serviceType.toLowerCase()),
    differential: localContentVariations.differential[idx],
    coverage: localContentVariations.coverage[idx]
      .replace('{neighborhood}', neighborhood),
    cta: localContentVariations.cta[idx]
      .replace('{neighborhood}', neighborhood)
  };
};

// City detection helper
export const detectCity = (neighborhoodSlug) => {
  // Neighborhoods in Aparecida de Goiânia
  const aparecidaNeighborhoods = [
    'jardim-olimpico',
    'jardins-milao', 
    'vila-redencao',
    'parque-trindade'
  ];
  
  if (aparecidaNeighborhoods.includes(neighborhoodSlug)) {
    return 'Aparecida de Goiânia';
  }
  
  return 'Goiânia';
};

// Generate unique meta descriptions
export const generateMetaDescription = (serviceType, neighborhood, city) => {
  const templates = [
    `${serviceType} em ${neighborhood}, ${city}. Serviço premium com galpão coberto, produtos profissionais e equipe especializada. Agende agora na Box7go!`,
    `Procurando ${serviceType.toLowerCase()} em ${neighborhood}? A Box7go oferece qualidade premium em ${city}. Agende pelo WhatsApp!`,
    `${serviceType} de qualidade em ${neighborhood}, ${city}. Galpão coberto, produtos premium e resultados garantidos. Solicite orçamento!`,
    `Box7go: ${serviceType.toLowerCase()} premium em ${neighborhood}. Atendemos toda região de ${city} com excelência. Fale conosco!`
  ];
  
  // Use neighborhood name hash to pick a template
  const hash = neighborhood.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return templates[hash % templates.length];
};

// Generate unique H1
export const generateH1 = (serviceType, neighborhood) => {
  const templates = [
    `${serviceType} ${neighborhood} com Qualidade Premium`,
    `${serviceType} de Excelência em ${neighborhood}`,
    `${serviceType} Premium em ${neighborhood}`,
    `${serviceType} Profissional ${neighborhood}`
  ];
  
  const hash = neighborhood.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return templates[hash % templates.length];
};

// Local keywords for optimization
export const localKeywords = {
  lavaJato: [
    'lava jato',
    'lavagem automotiva',
    'lava rápido',
    'lavagem de carro',
    'limpeza automotiva'
  ],
  estetica: [
    'estética automotiva',
    'detalhamento automotivo',
    'polimento automotivo',
    'cristalização de pintura',
    'vitrificação automotiva'
  ]
};
